export default {
  title: 'Szczegóły ceny',
  subtotal: 'Suma częściowa',
  method_fee: 'Opłata za dostawę',
  tip: 'Napiwek',
  service_fee: 'Obsługa online',
  payment_method_upcharge_fee: 'Opłata PayPal',
  discount: 'Rabat',
  taxes: 'Podatki',
  total: 'Suma',
};
